export { default } from "./isMuiElement.js";